import { useContext } from 'react';

import { CustomerContextProvider } from '../components/CustomerContextProvider';
import { CustomerContext } from '../context/CustomerContext';
import { type CustomerContext as CustomerContextType } from '../types';

const useCustomerContext = (): CustomerContextType => {
    const context = useContext(CustomerContext);

    if (context === undefined) {
        throw new Error(
            `${useCustomerContext.name} must be used within a ${CustomerContextProvider.name}`,
        );
    }

    return context;
};

export { useCustomerContext };
